import {
  Megaphone,
  AlertTriangle,
  BarChart3,
  Building2,
  CalendarDays,
  CalendarRange,
  ClipboardCheck,
  Clock,
  Contact,
  FileText,
  Globe,
  GraduationCap,
  Home,
  Inbox,
  ListTodo,
  MessageSquare,
  Newspaper,
  Trophy,
  Users,
} from 'lucide-react'
import type { ReactNode } from 'react'

/**
 * A picture for each destination (D-322, D-323).
 *
 * **Separate from `nav.ts` on purpose.** That file decides who may go where and
 * is pure data with no React in it, which is what lets it be tested as
 * arithmetic. An icon is presentation, and putting JSX beside the rules would
 * make the rules a `.tsx` and drag a renderer into every test of them.
 *
 * **Every destination needs one**, because the rail is icon-only between 640px
 * and 1024px and a slot with no picture there is a blank a person has to guess
 * at. A test binds this map to `ALL_DESTINATIONS` so adding a destination
 * without an icon fails rather than ships.
 */
const ICONS: Record<string, ReactNode> = {
  home: <Home size={18} />,

  // The whole studio's timetable against her own days: a range against a day.
  calendar: <CalendarRange size={18} />,

  // The same triangle the warning chip carries, so the rail entry and the
  // shout that sends her to it are recognisably one thing (D-585).
  conflicts: <AlertTriangle size={18} />,
  schedule: <CalendarDays size={18} />,

  // A list of things waiting on somebody, which is what an ask is. Inbox is
  // taken by Registrations, and two destinations wearing one picture is a rail
  // you have to read rather than recognise.
  asks: <ListTodo size={18} />,
  classes: <Users size={18} />,
  news: <Newspaper size={18} />,
  messages: <MessageSquare size={18} />,
  attendance: <ClipboardCheck size={18} />,
  people: <Contact size={18} />,
  competitions: <Trophy size={18} />,
  hours: <Clock size={18} />,
  reports: <BarChart3 size={18} />,
  'class-admin': <GraduationCap size={18} />,
  studio: <Building2 size={18} />,
  feedback: <MessageSquare size={18} />,
  // What we are telling them, beside what they told us (D-790).
  notices: <Megaphone size={18} />,
  website: <Globe size={18} />,
  forms: <FileText size={18} />,
  registrations: <Inbox size={18} />,
}

export function iconFor(key: string): ReactNode {
  return ICONS[key] ?? null
}

export const ICON_KEYS = Object.keys(ICONS)
